import React, { Component, Fragment } from 'react';

import { Button } from 'components/button';
import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class ConfigStreamingModal extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
  };

  state = {
    confirmed: false
  };

  togleConfirmed = () => {
    return this.setState((prevState) => ({
      confirmed: !prevState.confirmed
    }));
  };

  render() {
    const { onCancel, onConfirm } = this.props;

    return (
      <Modal
        title="config_manager.config_streaming.activate_streaming_warning_template_title"
        onClose={onCancel}
      >
        <Modal.Body>
          <div>
            <p>
              <I18n label="config_manager.config_streaming.activate_streaming_warning_template" />
            </p>
            <p>
              <I18n label="general.are_u_sure" />
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Fragment>
            <Fragment>
              <Button size="large" onClick={onConfirm}>
                <I18n label="general.ok" />
              </Button>
              <Button size="large" outline onClick={onCancel}>
                <I18n label="general.cancel" />
              </Button>
            </Fragment>
          </Fragment>
        </Modal.Footer>
      </Modal>
    );
  }
}
